<template>
    <div class="developMap">
        <Header @getLoginInfo="getLoginInfoFn"></Header>

        <!-- 面包屑 -->
        <div style="width:100%;overflow:hidden;">
            <div class="underHeader">
                <img :src="local" style="width:12px;display:inline-block;"/>
                当前位置：
                <a href="/#/index">平台首页 ></a>
                发展概况
            </div>
        </div>
        
        <el-container style="height: 813px;margin: 0 auto 21px;width:98%;">
            <!-- 左侧部分 -->
            <el-aside width="24%">
                <div class="graph_box">
                    <div class="graph_title">
                        <img :src="graph_title" alt="">
                        实有市场主体类型分布
                    </div>
                    <div class="graphs" id="graphPie1"></div>
                </div>
                <div class="graph_box" style="margin-top:13px;">
                    <div class="graph_title">
                        <img :src="graph_title" alt="">
                        实有市场主体登记状态
                    </div>
                    <div class="graphs" id="graphPie2"></div>
                </div>
                <div class="graph_box" style="margin-top:14px;">
                    <div class="graph_title">
                        <img :src="graph_title" alt="">
                        实有市场主体行业TOP5
                    </div>
                    <div class="graphs" id="graphBar1"></div>
                </div>
            </el-aside>
            <el-main style="position:relative;">
                <div class="numBox">
                    <span class="info_new" style="margin-left:30px;">期末实有市场主体总量：</span>
                    <div class="box-items" id="TNum">
                        <li class="number-item"><span><i>0123456789</i></span></li>
                    </div>
                    <span class="info_new" style="margin-left:6px;">家</span>

                    <!-- <span class="info" style="float:right;margin-right:30px;margin-left:6px;">年月</span>
                    <div class="box-items" id="TNum2" style="float:right;">
                        <li class="number-item"><span><i>0123456789</i></span></li>
                    </div> -->
                    <div id="change_time_box" class="info" style="float:right;margin-right:30px;margin-left:6px; font-size:18px;">
                        <!-- 2020年01月 -->
                    </div>
                    <span class="info" style="float:right;">当前数据时间：</span>
                    
                </div>

                <el-row style="margin-top:32px;padding:0 20px;position:absolute;top:18px;left:19px;z-index:10000;">
                    <div v-show="maps.provinceName" id="returnBackBtn" class="returnPrevMap">上级地图</div>
                </el-row>
                
                <div id="chinaMap" style="width:100%;height:536px;"></div>
                <div style="width:100%;height:262px;margin-top:12px;overflow:hidden;">
                    <div class="graph_box" style="float:left;width:49%;">
                        <div class="graph_title">
                            <img :src="graph_title" alt="">
                            历史死亡企业行业分布排名
                        </div>
                        <div class="graphs" id="graphFunnel1"></div>
                    </div>
                    <div class="graph_box" style="float:left;width:49%;margin-left: 1.2%;">
                        <div class="graph_title">
                            <img :src="graph_title" alt="">
                            新增死亡企业行业分布排名
                        </div>
                        <div class="graphs" id="graphFunnel2"></div>
                    </div>
                </div>
            </el-main>
            <!-- 右侧部分 -->
            <el-aside width="24%">
                <div class="graph_box">
                    <div class="graph_title">
                        <img :src="graph_title" alt="">
                        新增企业登记类型Top5
                    </div>
                    <div class="graphs" id="graphBar2"></div>
                </div>
                <div class="graph_box" style="margin-top:13px;">
                    <div class="graph_title">
                        <img :src="graph_title" alt="">
                        区域新登记主体类型分布
                    </div>
                    <div class="graphs" id="graphBuble"></div>
                </div>
                <div class="graph_box" style="margin-top:14px;">
                    <div class="graph_title">
                        <img :src="graph_title" alt="">
                        新增市场主体行业TOP5
                    </div>
                    <div class="graphs" id="graphBar3"></div>
                </div>
            </el-aside>
        </el-container>
        <el-container style="height: 60px;margin: 0 auto;width:98%;">
            <div id="timeLine" style="width:100%;height:100%;"></div>
        </el-container>
        <Footer style="margin-top:25px;"></Footer>
    </div>
</template>
<script>

import echarts from 'echarts';
import cityMap from "@/../static/plugins/chinese-map/static/js/citymap.js";
import $ from 'jquery';
import magic from "@/../static/common/magic.js";

import Header from "@/components/header";
import Footer from "@/components/footer";

import local from "@/assets/map/local.png";
import graph_title from "@/assets/map/graph_title.png";

export default {
    data() {
        let _self = this;
        return {
            loginInfo:'',//登录信息
            local,
            graph_title,
            maps:{//地图参数
                bigNum: 0, //当前地图数据里的最大值
                province: '',//当前地图在哪一级别全国是province，''/province/city/district
                provinceName: '',//当前省份的名字，全国的时候可以为空
                seriesName: 'china',//在点击地图下钻时添加，记住当前的级别，方便切换条件的时候还能加载当前级别
                provinceData: [],//因为省级的数据是带省市自治区的，下面已经被我去掉了，在此保存一下，将带省市拿来传给后台当参数用,否则不管用
                stashArry: [],//记住每一级地图的名字，为返回上一级做准备
            },
            currentIndex: 0,//时间轴当前的下标
            dataList: [],//时间轴
            curTime: ''//当前的时间点
        };
    },
    watch: {
        curTime(val,oldVal){
            this.chinaMap();
        }
    },
    components:{
        Header,
        Footer,
    },
    mounted() {        

        this.chinaMap();

        let userAgent = navigator.userAgent; 
        if (userAgent.indexOf("Firefox") > -1) {//火狐下数据框样式有兼容性问题
            $('#app .developMap .number-item span i').css('top','-2px');
        } //判断是否Firefox浏览器

    },
    methods: {
        //获取header返回来的登录信息
        getLoginInfoFn(val) {
            this.loginInfo = val;
        },
        //饼图函数:图一
        graph_pie1(params) {
            var myCake = echarts.init(document.getElementById("graphPie1"));
            var option = {
                // tooltip: {
                //     trigger: "item",
                //     formatter: "{b}: {c}"
                // },
                tooltip: {
                    trigger: "item",
                    // formatter: "{b}: {c}"
                    formatter: (params, ticket, callback) => {
                            
                        return `存续：${(params.value/10000).toFixed(2)}万家`
                    }
                },
                legend: {
                    //图例
                    // orient: 'vertical',
                    // right: 'center',
                    bottom:5,
                    data: [],
                    textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 400
                    }
                },
                series: [
                {
                    name: "访问来源",
                    type: "pie",
                    radius: ["32%", "45%"], //半径
                    avoidLabelOverlap: false,
                    color: [
                          "#177fe8",
                          "#ef7041",
                          "#a8d9ab",
                          "#03aab9",
                          "#88cff8",
                          "#ded668",
                          "#c0e272",
                    ],
                    label: {
                        show: false,
                        position: "center",
                        normal: {
                            //指示线指示文字
                            show: true,
                            position: "outside",
                            formatter: "{d}%",
                            textStyle: {
                                fontWeight: 400,
                                fontSize: 12,
                                color: "#fff"
                            }
                        }
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: "12",
                            fontWeight: "bold"
                        }
                    },
                    labelLine: {
                        show: false,
                        normal: {
                            //指示线指示文字
                            show: true,
                            length: 40,
                            length2: 27,
                            lineStyle: {
                                width: 1
                            }
                        }
                    },
                    // itemStyle: {
                    //     borderWidth: 1,
                    //     borderColor: "#fff"
                    // },
                    data: []
                    // data: [
                    //   { value: , name: "" },
                    // ]
                }
                ]
            };

            if(params.length > 0){
                params.forEach(item => {
                    if(item.name){
                        var newArr = {};
                        newArr.value = item.num;
                        newArr.name = item.name;
                        option.legend.data.push(item.name);
                        option.series[0].data.push(newArr);
                    }
                });
                myCake.setOption(option);
            }
        },
        //饼图函数:图二
        graph_pie2(params) {
            var myCake = echarts.init(document.getElementById("graphPie2"));
            // var color = ['#FC4567', '#2F8DF4', '#C25EC4']
            var color = ["#177fe8","#ef7041","#a8d9ab","#03aab9","#88cff8","#ded668","#c0e272",];
            var option = {
                color: color,
                // tooltip: {
                //     trigger: 'item'
                // },
                tooltip: {
                    trigger: "item",
                    // formatter: "{b}: {c}"
                    formatter: (params, ticket, callback) => {
                            
                        return `存续：${(params.value/10000).toFixed(2)}万家`
                    }
                },
                legend: {
                    // orient: 'vertical',
                    // right: 5,
                    // top: 20,
                    bottom:5,
                    data:[],
                    textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 400
                    }
                },
                series: [{
                    type: 'pie',
                    roseType: 'radius',
                    radius: ['30%', '50%'],
                    data: [],
                    label: {
                        normal: {
                            formatter: '{d}%',
                            rich: {
                                font: {
                                    fontSize: 12,
                                    padding: [5, 0],
                                    color: '#fff'
                                },
                                hr: {
                                    height: 0,
                                    borderWidth: 1,
                                    width: '100%',
                                    borderColor: '#fff'
                                }
                            }
                        },
                    },
                    labelLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0,0,0,0.5)'
                        }
                    }
                }]
            };

            if(params.length > 0){
                params.forEach(item => {
                    if(item.name){
                        var newArr = {};
                        newArr.value = item.num;
                        newArr.name = item.name;
                        option.legend.data.push(item.name);
                        option.series[0].data.push(newArr);
                    }
                });
                myCake.setOption(option);
            }

        },
        //柱状图函数:图三
        graph_bar1(params) {
            var myCake = echarts.init(document.getElementById("graphBar1"));
            var option = {
                grid: {
                    left: '0',
                    // right: '1',
                    // bottom: '5%',
                    top: '5.8%',
                    width:'78%',
                    height: '93%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    // formatter: function(params) {
                    //     return params[0].name + '<br/>' +
                    //         "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
                    //         params[0].seriesName + ' : ' + params[0].value + ' 万元<br/>'
                    // },
                    formatter: (param, ticket, callback) => {
                        // console.log(param, ticket,'test')
                        return `${param[0].seriesName}：${(param[0].value/10000).toFixed(4)}万家`
                    }
                    
                },
                xAxis: {
                    show: false,
                    type: 'value'
                },
                yAxis: [{
                    type: 'category',
                    offset: -10,
                    position: "left",
                    axisLine: {
                        show: false
                    },
                    inverse: false,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: 0,
                        color: ["#fff"],
                        align: "left",
                        verticalAlign: "bottom",
                        lineHeight: 30,
                        fontSize: 12,
                    },
                    data: [] //['大米', '玉米', '蔬菜', '鸡蛋', '坚果']
                }, {
                    type: 'category',
                    // inverse: true,
                    axisTick: 'none',
                    axisLine: 'none',
                    show: true,
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',
                            fontSize: '12'
                        },
                        formatter: function(value) {
                            if (value >= 10000) {
                                return (value / 10000).toLocaleString() + '万家';
                            } else {
                                return value.toLocaleString();
                            }
                        },
                    },
                    data: []//[50000000, 22000000, 10000000, 5000000, 1]
                }],
                series: [
                    {
                        name: '数量',
                        type: 'bar',
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                    offset: 0,
                                    color: 'rgb(57,89,255,1)'
                                }, {
                                    offset: 1,
                                    color: 'rgb(46,200,207,1)'
                                }]),
                            },
                        },
                        barWidth:10,
                        data: []//[50000000, 22000000, 10000000, 5000000, 1]
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth:10,
                        barGap: '-100%',
                        data: [],//[50000000, 50000000, 50000000, 50000000, 1],
                        itemStyle: {
                            normal: {
                                color: 'rgba(24,31,68,1)',
                                barBorderRadius: 30,
                            }
                        },
                    },
                ]
            };

            if(params.length > 0){
                var newArr1 = [];
                var newArr2 = [];
                params.forEach(item => {
                    if(item.name){

                        option.series[0].data.push(item.num);
                        option.series[1].data.push(item.num);

                        option.yAxis[0].data.push(item.name);
                        option.yAxis[1].data.push(item.num);
                    }
                });

                myCake.setOption(option);
            }
        },
        //柱状图函数:图六
        graph_bar2(params) {
            var myCake = echarts.init(document.getElementById("graphBar2"));
            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (params, ticket, callback) => {
                            
                        return `${params[0].name}：${(params[0].value/1000).toFixed(2)}千家`
                    }
                },
                grid: {
                    top: '10%',
                    right: '1%',
                    left: '10%',
                    bottom: '15%'
                },
                xAxis: [{
                    type: 'category',
                    data: [],//['湖北', '福建', '山东', '广西', '浙江', '河南', '河北']
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(255,255,255,0.12)'
                        }
                    },
                    axisLabel: {
                        margin: 10,
                        color: '#e2e9ff',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                }],
                yAxis: [{
                    // type: 'value',
                    // name: '千家',
                    splitNumber: 3,
                    axisLabel: {
                        formatter: function(value,index){
                            var value;
                            if (value >=1000) {
                                value = value/1000;
                            }else if(value <1000){
                                value = value;
                            }
                            return value
                        },
                        color: '#e2e9ff',
                        rotate:54 
                    },
                    axisLine: {
                        show: true
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: '#233e64'
                        }
                    },
                }],
                series: [{
                    type: 'bar',
                    data: [],//[300, 450, 770, 203, 255, 188, 156]
                    barWidth: '10px',
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(0,244,255,1)' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(0,77,167,1)' // 100% 处的颜色
                            }], false),
                            barBorderRadius: [30, 30, 30, 30],
                            shadowColor: 'rgba(0,160,221,1)',
                            shadowBlur: 4,
                        }
                    }
                }]
            };

            if(params.length > 0){
                
                var newArr1 = [];
                var newArr2 = [];
                params.forEach(item => {
                    if(item.name){
                        
                        newArr1.push(item.num);
                        newArr2.push(item.name);
                    }
                });
                option.series[0].data = newArr1;
                option.xAxis[0].data = newArr2;
                
                myCake.setOption(option);
            }

        },
        //柱状图函数:图八
        graph_bar3(params) {
            var myCake = echarts.init(document.getElementById("graphBar3"));
            var option = {
                grid: {
                    left: '0',
                    // right: '1',
                    // bottom: '5%',
                    top: '5.8%',
                    width:'78%',
                    height: '93%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none'
                    },
                    // formatter: function(params) {
                    //     return params[0].name + '<br/>' +
                    //         "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
                    //         params[0].seriesName + ' : ' + params[0].value + ' 万元<br/>'
                    // }
                    formatter: (params, ticket, callback) => {
                            
                        return `${params[0].seriesName}：${(params[0].value/10000).toFixed(4)}万家`
                    }
                },
                xAxis: {
                    show: false,
                    type: 'value'
                },
                yAxis: [{
                    type: 'category',
                    offset: -10,
                    position: "left",
                    axisLine: {
                        show: false
                    },
                    inverse: false,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: 0,
                        color: ["#fff"],
                        align: "left",
                        verticalAlign: "bottom",
                        lineHeight: 30,
                        fontSize: 12,
                    },
                    data: ['大米', '玉米', '蔬菜', '鸡蛋', '坚果']
                }, {
                    type: 'category',
                    // inverse: true,
                    axisTick: 'none',
                    axisLine: 'none',
                    show: true,
                    axisLabel: {
                        textStyle: {
                            color: '#ffffff',
                            fontSize: '12'
                        },
                        formatter: function(value) {
                            if (value >= 10000) {
                                return (value / 10000).toLocaleString() + '万家';
                            } else {
                                return value.toLocaleString();
                            }
                        },
                        
                    },
                    data: [50000000, 22000000, 10000000, 5000000, 1]
                }],
                series: [{
                        name: '数量',
                        type: 'bar',
                        zlevel: 1,
                        itemStyle: {
                            normal: {
                                barBorderRadius: 30,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                    offset: 0,
                                    color: 'rgb(57,89,255,1)'
                                }, {
                                    offset: 1,
                                    color: 'rgb(46,200,207,1)'
                                }]),
                            },
                        },
                        barWidth: 10,
                        data: [50000000, 22000000, 10000000, 5000000, 1]
                    },
                    {
                        name: '背景',
                        type: 'bar',
                        barWidth: 10,
                        barGap: '-100%',
                        data: [50000000, 50000000, 50000000, 50000000, 1],
                        itemStyle: {
                            normal: {
                                color: 'rgba(24,31,68,1)',
                                barBorderRadius: 30,
                            }
                        },
                    },
                ]
            };

            if(params.length > 0){
                var newArr1 = [];
                var newArr2 = [];
                params.forEach(item => {
                    if(item.name){
                        
                        newArr1.push(item.num);
                        newArr2.push(item.name);
                    }
                });

                option.series[0].data = newArr1;
                option.series[1].data = newArr1;

                option.yAxis[0].data = newArr2;
                option.yAxis[1].data = newArr1;

                myCake.setOption(option);
            }

        },
        //漏斗图函数:图四
        graph_funnel1(params) {
            var myCake = echarts.init(document.getElementById("graphFunnel1"));
            var option = {
                color: ["#0DC6D7","#03AAB9","#45A5F8","#177FE8","#0360B9"],
                tooltip: {
                    trigger: 'item',
                    formatter: "{b} : {c}家"
                },
                legend: {
                    orient: 'vertical',
                    right: 5,
                    top: 20,
                    textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 400
                    },
                    formatter: function (name) {
                        return ''
                    }
                },
                calculable: true,
                series: [{
                    name: 'DATA',
                    type: 'funnel',
                    left: 40,
                    right: 100,
                    top: '10%',
                    min: 0,
                    maxSize: '100%',
                    width: '60%',
                    height: '80%',
                    sort: 'ascending',
                    gap: 2,
                    label: {
                        show: true,
                        position: 'inside',
                        fontSize:12,
                        fontWeight:'bold',
                        color:'#fff'
                    },
                    labelLine: {
                        length: 10,
                        lineStyle: {
                            width: 1,
                            type: 'solid'
                        }
                    },
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1
                    },
                    data: []//{value: 10,name: 'A'}
                }]
            };

            if(params.length > 0){
                params.forEach(item => {
                    if(item.name){
                        var newArr = {};
                        newArr.value = item.num;
                        newArr.name = item.name;
                        // option.legend.data.push(item.name);
                        option.series[0].data.push(newArr);
                    }
                });
                myCake.setOption(option);
            }

        },
        //漏斗图函数:图五
        graph_funnel2(params) {
            var myCake = echarts.init(document.getElementById("graphFunnel2"));
            var option = {
                color: ["#0DC6D7","#03AAB9","#45A5F8","#177FE8","#0360B9"],
                tooltip: {
                    trigger: 'item',
                    formatter: "{b} : {c}家"
                },
                legend: {
                    orient: 'vertical',
                    right: 5,
                    top: 20,
                    textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 400
                    },
                    formatter: function (name) {
                        return ''
                    }
                },
                calculable: true,
                series: [{
                    name: 'DATA',
                    type: 'funnel',
                    left: 40,
                    right: 100,
                    top: '10%',
                    min: 0,
                    maxSize: '100%',
                    width: '60%',
                    height: '80%',
                    sort: 'ascending',
                    gap: 2,
                    label: {
                        show: true,
                        position: 'inside',
                        fontSize:12,
                        fontWeight:'bold',
                        color:'#fff'
                    },
                    labelLine: {
                        length: 10,
                        lineStyle: {
                            width: 1,
                            type: 'solid'
                        }
                    },
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 1
                    },
                    data: []//{value: 10,name: 'A'}
                }]
            };

            if(params.length > 0){
                params.forEach(item => {
                    if(item.name){
                        var newArr = {};
                        newArr.value = item.num;
                        newArr.name = item.name;
                        // option.legend.data.push(item.name);
                        option.series[0].data.push(newArr);
                    }
                });
                myCake.setOption(option);
            }

        },
        //气泡图函数:图七
        graph_buble(params) {
            var myCake = echarts.init(document.getElementById("graphBuble"));
            var option = {
                tooltip: {
                    trigger: "item",
                    // formatter: "{b}: {c}"
                    formatter: (params, ticket, callback) => {
                            
                        return `个体工商户：${(params.value/10000).toFixed(2)}万家`
                    }
                },
                legend: {
                    //图例
                    // orient: 'vertical',
                    // right: 'center',
                    bottom:5,
                    data: [],
                    textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 400
                    }
                },
                series: [
                {
                    name: "访问来源",
                    type: "pie",
                    radius: ["32%", "45%"], //半径
                    avoidLabelOverlap: false,
                    color: [
                          "#177fe8",
                          "#ef7041",
                          "#a8d9ab",
                          "#03aab9",
                          "#88cff8",
                          "#ded668",
                          "#c0e272",
                    ],
                    label: {
                        show: false,
                        position: "center",
                        normal: {
                            //指示线指示文字
                            show: true,
                            position: "outside",
                            formatter: "{d}%",
                            textStyle: {
                                fontWeight: 400,
                                fontSize: 12,
                                color: "#fff"
                            }
                        }
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: "12",
                            fontWeight: "bold"
                        }
                    },
                    labelLine: {
                        show: false,
                        normal: {
                            //指示线指示文字
                            show: true,
                            length: 40,
                            length2: 27,
                            lineStyle: {
                                width: 1
                            }
                        }
                    },
                    // itemStyle: {
                    //     borderWidth: 1,
                    //     borderColor: "#fff"
                    // },
                    data: []
                    // data: [
                    //   { value: , name: "" },
                    // ]
                }
                ]
            };

            if(params.length > 0){
                params.forEach(item => {
                    if(item.name){
                        var newArr = {};
                        newArr.value = item.num;
                        newArr.name = item.name;
                        option.legend.data.push(item.name);
                        option.series[0].data.push(newArr);
                    }
                });
                myCake.setOption(option);
            }
        },
        //原来的气泡图，目前更改成饼图
        //graph_buble(params) {
            // var myCake = echarts.init(document.getElementById("graphBuble"));
            // //偏移量
            // var offsetData = [
            //     [16, 27],
            //     [35, 73],
            //     [30, 33],
            //     [60, 33],
            //     [10, 48],
            //     [10, 48],
            //     [10, 48]
            // ];
            // var option = {
            //     tooltip: {},
            //     // animationDurationUpdate: function(idx) {
            //     //     // 越往后的数据延迟越大
            //     //     return idx * 100;
            //     // },
            //     // animationEasingUpdate: 'bounceIn',
            //     color: ['#fff', '#fff', '#fff'],
            //     series: [{
            //         type: 'graph',
            //         layout: 'force',
            //         force: {
            //             repulsion: 100,
            //             edgeLength: 10
            //         },
            //         roam: true,
            //         label: {
            //             show:true,
            //             normal: {
            //                 show: true,
            //                 formatter: function (param) {
            //                     //文字超过6个就截取一下
            //                     return param.name.length >= 6 ? param.name.substring(0,6) + '...' : param.name;
            //                 },
            //             },
            //         },
            //         data: []
            //         // [{
            //         //     "name": "考研",
            //         //     "value": offsetData[0],
            //         //     "symbolSize": 50,
            //         //     "draggable": true,
            //         //     "itemStyle": {
            //         //         "normal": {
            //         //             "color": new echarts.graphic.RadialGradient(0.3, 0.5, 0.7, [{
            //         //                     offset: 0,
            //         //                     color: "rgba(4,88,120,0)"
            //         //                 },
            //         //                 {
            //         //                     offset: 1,
            //         //                     color: "rgba(1,98,156,0.6)"
            //         //                 }
            //         //             ]),
            //         //             "opacity": 0.8,
            //         //             "shadowColor": '#045878',
            //         //             "shadowBlur": 10,
            //         //             "shadowOffsetX": 1,
            //         //             "shadowOffsetY": 1,
            //         //         },
            //         //     }
            //         // }]
            //     }]
            // }

            // let itemStyle = {
            //     "normal": {
            //         "color": new echarts.graphic.RadialGradient(0.3, 0.35, 0.72, [{
            //                 offset: 0.2,
            //                 // color: "rgba(4,88,120,0)"
            //                 color: "#177fe8"
            //             },
            //             {
            //                 offset: 1,
            //                 // color: "rgba(1,98,156,0.9)"
            //                 color: "#03aab9"
            //             }
            //         ]),
            //         "opacity": 1,
            //         "shadowColor": '#045878',
            //         "shadowBlur": 20,
            //         "shadowOffsetX": 1,
            //         "shadowOffsetY": 1,
                    
            //     },
            // }

            // let draggable = true;

            // if(params.length > 0){
            //     params.forEach(item => {
            //         if(item.name){
            //             var newArr = {};

            //             newArr.itemStyle = itemStyle;
            //             newArr.draggable = draggable;

            //             newArr.value = item.num;
            //             newArr.name = item.name;

            //             if(item.num <= 100){
            //                 newArr.symbolSize = item.num / 3;
            //             }else if(item.num <= 500 && item.num > 100){
            //                 newArr.symbolSize = item.num / 6;
            //             }else if(item.num <= 1000 && item.num > 500){
            //                 newArr.symbolSize = item.num / 14;
            //             }else if(item.num <= 5000 && item.num > 1000){
            //                 newArr.symbolSize = item.num / 34;
            //             }else if(item.num <= 8000 && item.num > 5000){
            //                 newArr.symbolSize = item.num / 64;
            //             }else if(item.num <= 14000 && item.num > 8000){
            //                 newArr.symbolSize = item.num / 104;
            //             }else if(item.num <= 23000 && item.num > 14000){
            //                 newArr.symbolSize = item.num / 204;
            //             }else if(item.num <= 43000 && item.num > 23000){
            //                 newArr.symbolSize = item.num / 404;
            //             }else if(item.num <= 73000 && item.num > 43000){
            //                 newArr.symbolSize = item.num / 654;
            //             }else if(item.num <= 103000 && item.num > 73000){
            //                 newArr.symbolSize = item.num / 954;
            //             }else{
            //                 newArr.symbolSize = item.num / 1000;
            //             }
    
            //             option.series[0].data.push(newArr);
            //         }
            //     });
            //     myCake.setOption(option);
            // }

        //},
        timeLineFn(params, defaultTime) {
            let _this = this;
            if(defaultTime){
                var defaultIndex = params.indexOf(defaultTime);
                console.log(defaultIndex,'defaultIndex')
                _this.currentIndex = defaultIndex;
            }
            let timeLine = echarts.init(document.getElementById("timeLine"));
            let option = {
                timeline: {
                    data: params,
                    axisType: "category",
                    autoPlay: false,
                    playInterval: 3000,
                    left: "0",
                    right: "0",
                    bottom: "5%",
                    width: "100%",
                    //  height: null,
                    label: {
                        normal: {
                            textStyle: {
                                color: 'rgb(179, 239, 255)'
                            }
                        },
                        emphasis: {
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    currentIndex: _this.currentIndex,
                    symbolSize: 10,
                    lineStyle: {
                        color: '#3097FE'
                    },
                    checkpointStyle: {
                        borderColor: '#D5EBFF',
                        color: '#0360B9',
                        borderWidth: 2,
                    },
                    controlStyle: {
                        showNextBtn: true,
                        showPrevBtn: true,
                        normal: {
                            color: '#53D9FF',
                            borderColor: '#53D9FF'
                        },
                        emphasis: {
                            color: 'rgb(58,115,192)',
                            borderColor: 'rgb(58,115,192)'
                        }
                    }
                }
            };
            timeLine.setOption(option);
            timeLine.on("timelinechanged", v => {

                _this.currentIndex = v.currentIndex;
                _this.curTime = _this.dataList[_this.currentIndex];
                
            });
        },
        //中国地图函数
        chinaMap(){
            let _this = this;
            //地图容器
            let chart = echarts.init(document.getElementById('chinaMap'));
            //34个省、市、自治区的名字拼音映射数组
            let provinces = {
                //23个省
                "台湾": "taiwan",
                "河北": "hebei",
                "山西": "shanxi",
                "辽宁": "liaoning",
                "吉林": "jilin",
                "黑龙江": "heilongjiang",
                "江苏": "jiangsu",
                "浙江": "zhejiang",
                "安徽": "anhui",
                "福建": "fujian",
                "江西": "jiangxi",
                "山东": "shandong",
                "河南": "henan",
                "湖北": "hubei",
                "湖南": "hunan",
                "广东": "guangdong",
                "海南": "hainan",
                "四川": "sichuan",
                "贵州": "guizhou",
                "云南": "yunnan",
                "陕西": "shanxi1",
                "甘肃": "gansu",
                "青海": "qinghai",
                //5个自治区
                "新疆": "xinjiang",
                "广西": "guangxi",
                "内蒙古": "neimenggu",
                "宁夏": "ningxia",
                "西藏": "xizang",
                //4个直辖市
                "北京": "beijing",
                "天津": "tianjin",
                "上海": "shanghai",
                "重庆": "chongqing",
                //2个特别行政区
                "香港": "xianggang",
                "澳门": "aomen"
            };

            //直辖市和特别行政区-只有二级地图，没有三级地图
            let special = ["北京","天津","上海","重庆","香港","澳门"];
            let mapdata = [];
            chart.off('click');//解决点击事件点击一次调用多次的问题
            
            //绘制全国/地区地图
            _this.maps.provinceName == '' ? loadChinaMap() : loadOthersMap({name: _this.maps.provinceName, seriesName: _this.maps.seriesName});
            
            function loadChinaMap(){
                $.getJSON('@/../static/plugins/chinese-map/static/map/china.json', function(data){
                    // console.log(data,'dataaaaaa')
                    _this.maps.provinceName = '';
                    _this.maps.seriesName = '';
                    _this.maps.province = '';
                    _this.maps.stashArry.push('china');//记住当前的名称
                    
                    //获取当前地图数据值
                    _this.getMapsData().then(res => {
                        
                        let d = [];
                        for( let i=0;i<data.features.length;i++ ){
                            for(let j=0;j<res.length;j++){
                                if(res[j].name == data.features[i].properties.name){
                                    d.push({
                                        name:data.features[i].properties.name,
                                        value:res[j].totalNum ? res[j].totalNum : 0
                                    })
                                }
                                res[j].totalNum > _this.maps.bigNum ? _this.maps.bigNum = res[j].totalNum : '';//获取最大值
                            }
                        }
                        // console.log(d,'d');
                        mapdata = d;
                        //注册地图
                        echarts.registerMap('china', data);
                        //绘制地图
                        renderMap('china',d);
                    });
                });
            }
            

            //天地图的返回按钮返回到全国地图
            $('#returnBackBtn').off('click');
            $('#returnBackBtn').on('click',function(){

                let trashArr = Array.from(new Set(_this.maps.stashArry));
                
                if(trashArr.length == 2){

                    _this.maps.stashArry = [];
                    loadChinaMap();
                }else if(trashArr.length > 2){

                    trashArr = trashArr.slice(0,trashArr.length-1);
                    _this.maps.stashArry = trashArr;
                    _this.maps.seriesName = trashArr[trashArr.length-2];
                    _this.maps.provinceName = trashArr[trashArr.length-1];
                    loadOthersMap({name: trashArr[trashArr.length-1], seriesName: trashArr[trashArr.length-2]});
                }
                _this.maps.showTMap = false;
            })

            //地图点击事件
            chart.on('click', function (params) {
                
                magic.loginOrRights(2).then(res => {
                    if (!res) {
                        _this.$message.error("请您登录！");
                        return;
                    }
                    if (res && res.rights == 0) {
                        _this.$message.error("您没有权限！");
                        return;
                    }

                    _this.maps.seriesName = params.seriesName;
                    _this.maps.provinceName = params.name;
                    _this.maps.stashArry.push(params.name);//记住当前的名称
                    loadOthersMap(params);
                    
                    // 埋点
                    try {
                        //LogCollection.contents["key"]="value";
                        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
                        LogCollection.send(9);
                    } catch (e) {}
                });
            });

            //加载省市县区地图函数
            function loadOthersMap(params){

                if( params.name in provinces ){
                    //如果点击的是34个省、市、自治区，绘制选中地区的二级地图
                    if(provinces[params.name] == 'taiwan'){//台湾不下钻
                        return;
                    }
                    
                    $.getJSON('@/../static/plugins/chinese-map/static/map/province/'+ provinces[params.name] +'.json', function(data){
                        echarts.registerMap( params.name, data);
                        _this.maps.province = 'province';

                        //获取当前地图数据值
                        _this.getMapsData().then(res => {
                            let d = [];
                            _this.maps.bigNum = 0;
                            for( var i=0;i<data.features.length;i++ ){
                                for(let j=0;j<res.length;j++){
                                    if(res[j].name == data.features[i].properties.name){
                                        d.push({
                                            name:data.features[i].properties.name,
                                            value:res[j].totalNum ? res[j].totalNum : 0
                                        })
                                    }
                                    res[j].totalNum > _this.maps.bigNum ? _this.maps.bigNum = res[j].totalNum : '';//获取最大值
                                }
                            }
                            _this.maps.showTMap = false;
                            renderMap(params.name,d);
                        });
                    });
                }else if( params.seriesName in provinces ){
                    //如果是【直辖市/特别行政区】只有二级下钻
                    if(  special.indexOf( params.seriesName ) >=0  ){
                        
                        // renderMap('china',mapdata);
                        loadChinaMap()
                        
                    }else{
                        //显示县级地图
                        $.getJSON('@/../static/plugins/chinese-map/static/map/city/'+ cityMap[params.name] +'.json', function(data){
                        // _this.getGeoJson(cityMap[params.name]).then(data =>{
                            echarts.registerMap( params.name, data);
                            _this.maps.province = 'city';
                            
                            //获取当前地图数据值
                            _this.getMapsData().then(res => {
                                let d = [];
                                _this.maps.bigNum = 0;
                                for( var i=0;i<data.features.length;i++ ){
                                    for(let j=0;j<res.length;j++){
                                        if(res[j].name == data.features[i].properties.name){
                                            d.push({
                                                name:data.features[i].properties.name,
                                                value:res[j].totalNum ? res[j].totalNum : 0
                                            })
                                        }
                                        res[j].totalNum > _this.maps.bigNum ? _this.maps.bigNum = res[j].totalNum : '';//获取最大值
                                    }
                                }
                                _this.maps.showTMap = false;
                                renderMap(params.name,d);
                            });
                        });	
                    }	
                }else{
                    
                    // renderMap('china',mapdata);
                    loadChinaMap()
                    
                }
            }

            //初始化绘制全国地图配置
            var option = {
                // backgroundColor: '#fff',
                title : {
                    // text: 'Echarts3 中国地图下钻至县级',
                    // subtext: '三级下钻',
                    left: 'center',
                    textStyle:{
                        color: '#121212',
                        fontSize:16,
                        fontWeight:'normal',
                        fontFamily:"Source Han Sans CN"
                    },
                    subtextStyle:{
                        color: '#121212',
                        fontSize:13,
                        fontWeight:'normal',
                        fontFamily:"Source Han Sans CN"
                    }
                },
                grid:{//设置canvas内部表格的内距
                    x:50,
                    y:50,
                    x2:50,
                    y2:0,
                    borderWidth:10
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}： {c}家'
                },
                toolbox: {
                    show: false,
                    orient: 'vertical',
                    left: 'right',
                    top: 'top',
                    iconStyle:{
                        normal:{
                            color:'#fff'
                        }
                    },
                    feature : {
                        mark : {                                 // '辅助线开关'
                            show: true
                        },
                        saveAsImage : {                         //保存为图片。
                            show: true,                         //是否显示该工具。
                            type:"png",                         //保存的图片格式。支持 'png' 和 'jpeg'。
                            name:"pic1",                        //保存的文件名称，默认使用 title.text 作为名称
                            backgroundColor:"#ffffff",        //保存的图片背景色，默认使用 backgroundColor，如果backgroundColor不存在的话会取白色
                            title:"中国地图",
                            pixelRatio:1                        //保存图片的分辨率比例，默认跟容器相同大小，如果需要保存更高分辨率的，可以设置为大于 1 的值，例如 2
                        },
                        // dataView: {readOnly: false},
                    },
                },
                animationDuration:1000,
                animationEasing:'cubicOut',
                animationDurationUpdate:1000,
                visualMap: {
                    min: 0,
                    max: 150,
                    left: '0',
                    bottom: '2px',
                    text: ['高', '低'],
                    calculable: true,
                    // seriesIndex: [1],
                    inRange: {
                        // color: ['#D2EAFF', '#177FE8']
                        color: ['#87cefa', '#dfed27', '#e6521b']
                    },
                    show: true,
                    textStyle:{
                        color: ['#DCE5F5'],
                    }
                },
                
            };
            function renderMap(map,data){
                option.visualMap.max = _this.maps.bigNum + 5;
                option.title.subtext = map;
                option.series = [ 
                    {
                        name: map,
                        type: 'map',
                        mapType: map,
                        roam: true,
                        zoom: 1.2,
                        nameMap:{
                            'china':'中国'
                        },
                        label: {
                            normal:{
                                show:true,
                                textStyle:{
                                    color:'#EFF7FF',
                                    fontSize:13
                                }  
                            },
                            emphasis: {
                                show: true,
                                textStyle:{
                                    color:'#fff',
                                    fontSize:13
                                }
                            }
                        },
                        itemStyle: {
                            // normal: {
                            //     areaColor: '#D2EAFF',
                            //     borderColor: '#043563',
                            //     shadowColor: '#043563',
                            //     shadowBlur: 10,
                            //     borderBlur: 10
                            // },
                            // emphasis: {
                            //     areaColor: '#4499d0',
                            // }
                            normal: {
                                borderColor: 'rgba(147, 235, 248, 1)',
                                borderWidth: 1,
                                areaColor: {
                                    type: 'radial',
                                    x: 0.2,
                                    y: 0.2,
                                    r: 0.9,
                                    colorStops: [{
                                        offset: 0, 
                                        color: 'rgba(147, 235, 210, 0)' // 0% 处的颜色
                                    }, {
                                        offset: 1, 
                                        color: 'rgba(147, 235, 210, .1)' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                // shadowColor: 'rgba(128, 217, 248, 1)',
                                shadowColor: '#043563',
                                shadowOffsetX: -2,
                                shadowOffsetY: 2,
                                shadowBlur: 10
                            },
                            emphasis: {
                                areaColor: '#389BB7',
                                borderWidth: 0
                            }
                        },
                        data:data
                    }	
                ];
                //渲染地图
                chart.setOption(option, true);
            }
            //点击导出地图按钮导出图片
            $('.returnImgDown').off('click');
            $('.returnImgDown').on('click',()=>{
                var img = new Image();
                img.src = chart.getDataURL({
                    type:"png",
                    pixelRatio: 2, //放大2倍
                    backgroundColor: '#fff'
                });
    
                img.onload=function(){
                    var canvas=document.createElement("canvas");
                    canvas.width=img.width;
                    canvas.height=img.height;
                    var ctx=canvas.getContext('2d');
                    ctx.drawImage(img,0,0);
                    var  dataURL=canvas.toDataURL('image/png');
    
                    var a = document.createElement('a');
                    // 创建一个单击事件
                    var event = new MouseEvent('click');
                    // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
                    a.download = '产业地图.png' || '产业地图';
                    // 将生成的URL设置为a.href属性
                    a.href = dataURL;
                    // 触发a的单击事件
                    a.dispatchEvent(event);
                };
            })
        },
        //给地图全国一级的名称添加省市自治区的字段
        changeProvinceName(name){

            let arr = this.maps.provinceData;
            
            if(arr.length > 0){
                
                let tmpArr = arr.filter((ele,i)=>{

                    if(ele.name.substring(ele.name.length-1) == '省' || ele.name.substring(ele.name.length-1) == '市'){
                        
                        return ele.name.substring(0,ele.name.length-1) == name;

                    }else if(ele.name.substring(ele.name.length-3) == '自治区'){

                        if(ele.name.substring(0,3) != '内蒙古'){
                            
                            return ele.name.substring(0,2) == name;

                        }else{
                            
                            return ele.name.substring(0,3) == name;
                        }
                    }
                });
                
                return tmpArr.length > 0 ? tmpArr[0].name : [];
            }
        },
        //获取地图数据
        getMapsData(){
            let _this = this;
            return new Promise(function(resolve, reject) {
                
                let params = { 
                    "selectLevel":_this.maps.province,
                    "selectName": (_this.maps.province == 'province') ? _this.changeProvinceName(_this.maps.provinceName) : _this.maps.provinceName,   //在全国的时候传空
                    "registration_date": _this.dataList.length ? _this.dataList[_this.currentIndex] : ''
                }
                    
                api.dmap_getAllData(params).then(res=>{
                    let data = res.data;
                    let values = [];
                    let companyTypeTotal = data.companyTypeTotal;                       //商事主体类型分布:图一
                    let managementFormsTotal = data.managementFormsTotal;               //商事主体状态分布:图二
                    let industryTotal  = data.industryTotal;                            //商事主体行业分布:图三
                    let capitalTotal = data.capitalTotal;                               //资金来源行业分布:图四
                    let capitalIncrease = data.capitalIncrease;                         //资金来源行业分布:图五
                    let companyTypeIncrease = data.companyTypeIncrease;                 //新登记主体类型分布:图六
                    let managementFormsIncrease =  data.managementFormsIncrease;        //区域新登记主体数量:图七
                    let industryIncrease = data.industryIncrease;                       //行业新登记主体数量:图八

                    let mapData = data.mapData;                                         //企业地图
                    
                    let totalNum = data.totalNum;                                       //期末实有市场主体总量
                    let registeredCapitalTotal = data.registeredCapitalTotal;           //资金总量

                    data.timeTitleList ? _this.dataList = data.timeTitleList : '';                                //时间轴添加全局变量
                    console.log(data,'data')
                    _this.graph_pie1(companyTypeTotal);
                    _this.graph_pie2(managementFormsTotal);
                    _this.graph_bar1(industryTotal);
                    _this.graph_bar2(companyTypeIncrease);
                    _this.graph_bar3(industryIncrease);
                    _this.graph_funnel1(capitalTotal);
                    _this.graph_funnel2(capitalIncrease);
                    _this.graph_buble(managementFormsIncrease);
                    _this.timeLineFn(_this.dataList, data.registrationDate);
                    _this.numBoxFn1(totalNum.length ? totalNum : [{num:0}]);
                    

                    let cutTmpTime = _this.curTime ? _this.curTime.split('-').join('') : _this.dataList[0].split('-').join('');
                   
                    // _this.numBoxFn2([{num: cutTmpTime}]);//时时显示当前时间
                    // if(!params.selectLevel){
                        $('#change_time_box').html(_this.dataList[_this.currentIndex].substring(0,4) + '年' + _this.dataList[_this.currentIndex].substring(5) + '月');
                    // }else{
                    //     $('#change_time_box').html(cutTmpTime.substring(0,4) + '年' + cutTmpTime.substring(4) + '月');
                    // }
                                        
                    if(params.selectLevel == ''){

                        _this.maps.provinceData = mapData;
                        let data = mapData;

                        for(let i=0;i<data.length;i++){

                            if(data[i].name.substring(data[i].name.length-1) == '省' || data[i].name.substring(data[i].name.length-1) == '市'){
                                values.push({
                                    name: data[i].name.substring(0,data[i].name.length-1),
                                    totalNum: data[i].totalNum
                                })
                            }else if(data[i].name.substring(data[i].name.length-3) == '自治区'){
                                if(data[i].name.substring(0,3) != '内蒙古'){
                                    values.push({
                                        name: data[i].name.substring(0,2),
                                        totalNum: data[i].totalNum
                                    })
                                }else{
                                    values.push({
                                        name: data[i].name.substring(0,3),
                                        totalNum: data[i].totalNum
                                    })
                                }
                            }
                        }
                        resolve(values);
                    }else{
                        
                        resolve(mapData);
                    }                    
                })   
            });
        },
        //数字显示函数
        numBoxFn1(params){
            var chartNum = [];     // 默认总数
            let data = String(params[0].num).split('');
            for(let i=0;i<data.length;i++){
                chartNum.push('0');
            }
            
            start1();
            function start1(){
                var strHtml = "";
                for(var i=0;i<chartNum.length;i++){
                    strHtml+= '<li class="number-item">\n' +
                        '                <span><i class="item" ref="numberItem">0123456789</i></span>\n' +
                        '            </li>';
                }
                $("#TNum").html(strHtml);

                let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
                if (userAgent.indexOf("Firefox") > -1) {//火狐样式有兼容问题，单独调试
                    $('#app .developMap .number-item span i').css('top','-2px');
                } //判断是否Firefox浏览器

                // 定时改变数字
                let timer = setInterval(function setInt(){
                    toOrderNum(params[0].num);
                    setNumberTransform();
                    clearInterval(timer);
                },1000)
            }

            function toOrderNum(num) {
                var num = num.toString()     // 数字变成字符串
                // if (num.length < 6) {  // 如未满位数，添加"0"补位
                //     num = '0' + num
                //     toOrderNum(num) // 递归添加"0"补位
                // } else if (num.length === 6) {      // 数中加入逗号
                //     // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
                //     chartNum = num.split('') // 将其便变成数据
                // } else {
                //     alert('显示异常');
                // }
                chartNum = num.split('') // 将其便变成数据
            }
            function setNumberTransform(){
                var numberItems = $('#TNum .item');
                const numberArr = chartNum.filter(item => !isNaN(item));
                for (var  index = 0; index < numberItems.length; index++) {
                    const elem = numberItems[index];
                    elem.style.transform = 'translate(-50%, -'+numberArr[index]  * 10 +'%)'
                }
            }
            
        },
        //数字显示函数-显示当前数据的月份
        numBoxFn2(params){
            var chartNum = [];     // 默认总数
            let data = String(params[0].num).split('');
            for(let i=0;i<data.length;i++){
                chartNum.push('0');
            }
            start2();
            function start2(){
                var strHtml = "";
                for(var i=0;i<chartNum.length;i++){
                    strHtml+= '<li class="number-item">\n' +
                        '                <span><i class="item" ref="numberItem">0123456789</i></span>\n' +
                        '            </li>';
                }
                $("#TNum2").html(strHtml);

                // 定时改变数字
                let timer = setInterval(function setInt(){
                    toOrderNum2(params[0].num);
                    setNumberTransform();
                    clearInterval(timer);
                },1000)
            }

            function toOrderNum2(num) {
                var num = num.toString()     // 数字变成字符串
                // if (num.length < 6) {  // 如未满位数，添加"0"补位
                //     num = '0' + num
                //     toOrderNum2(num) // 递归添加"0"补位
                // } else if (num.length === 6) {      // 数中加入逗号
                //     // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
                //     chartNum = num.split('') // 将其变成数据
                // } else {
                //     alert('显示异常');
                // }
                chartNum = num.split('') // 将其变成数据
            }
            function setNumberTransform(){
                var numberItems = $('#TNum2 .item');
                const numberArr = chartNum.filter(item => !isNaN(item));
                for (var  index = 0; index < numberItems.length; index++) {
                    const elem = numberItems[index];
                    elem.style.transform = 'translate(-50%, -'+numberArr[index]  * 10 +'%)'
                }
            }
            
        }
    }
};
</script>
<style lang="less">
.developMap {
    width: 100%;
    height: 100%;
    background: url('../../assets/map/bg.jpg') no-repeat top;
    background-size: 100% auto;
    // 面包屑样式
    .underHeader{
        display: inline-block;
        height: 55px;
        line-height: 55px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #DFECF7;
        margin-left:20px;
        overflow: hidden;
        a{
            color: #DFECF7;
        }
    }

    .el-aside {
        color: #333;
        text-align: center;
        line-height: 200px;
        overflow: hidden;
    }
    
    .el-main {
        color: #333;
        text-align: center;
        line-height: 160px;
        padding:0 12px;
        overflow: hidden;
    }
    .graph_box{
        height: 260px;
        width:99.5%;
        background: rgba(5, 43, 79, 0.3);
        border: 1px solid #08396A;
        border-radius: 2px;
        overflow: hidden;
        .graph_title{
            width:92%;
            height:45px;
            margin:0 auto;
            color: #DFECF7;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            line-height:45px;
            border-bottom:1px solid #08396A;
            text-align: left;
            img{
                width: 12px;
                height: 12px;
                display:inline-block;
            }
        }
        .graphs{
            width:92%;
            height:215px;
            margin: 0 auto;
        }
    }
    // 数字样式
    .numBox{
        position:absolute;
        top:0;
        left:0;
        width:99%;
        height:40px;
        z-index:1000;
        .info{
            height:38px;
            color:#DFECF7;
            line-height: 38px;
            display:inline-block;
            float: left;
        }
        .info_new{
            height:38px;
            color:#DFECF7;
            line-height: 38px;
            display:inline-block;
            float: left;
        }
        .leftNum{
            height:38px;
            width:280px;
            float: left;
            position:relative;
        }
    }

    .returnPrevMap{
        width: 96px;
        height: 32px;
        background: #177FE8;
        border-radius: 2px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #DFECF7;
        line-height: 32px;
        text-align:center;
        // float:left;
        cursor:pointer;
        position: absolute;
        top: 10px;
        left: 12px;
    }


    @font-face {
        font-family: 'Digital-7';
        src: url('./fonts/digital-7-4.ttf');
        font-weight: normal;
        font-style: normal
    }
    .chartNum{
        margin: 30px 0px;
        display: flex; 
        justify-content: center;
    }
    .box-items {
        width: auto;
        font-family: Digital-7;
        position: relative;
        height: 38px;
        text-align: center;
        list-style: none;
        writing-mode: vertical-lr;
        text-orientation: upright;
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        -khtml-user-select: none; /*早期浏览器*/
        user-select: none;
        float:left;
    }
    .mark-item span{
        position: absolute;
        width: 100%;
        bottom: 10px;
        writing-mode: vertical-rl;
        text-orientation: upright;
    }
    /*滚动数字设置*/
    .number-item {
        text-align: center;
        width: 24px;
        height: 38px;
        line-height: 38px;
        float: left;
        background: rgba(8, 57, 106, 0.5);
        border: 1px solid #08396A;
        border-radius: 2px;
        // box-shadow: 0 0 16px 0 #3F6BCB;
        list-style: none;
        ont-family: Digital-7;
        font-size: 22px;
        font-weight:bold;
        color: #1087FF;
        margin-right: 3px;
        display: flex;
        justify-content: center;
    }
    .number-item span{
        position: relative;
        display: inline-block;
        margin-right: 22px;
        width: 100%;
        height: 100%;
        writing-mode: vertical-rl;
        text-orientation: upright;
        overflow: hidden;
    }
    .number-item span i{
        font-style: normal;
        position: absolute;
        top: 8px;
        left: 50%;
        transform: translate(-50%,0);
        transition: transform 1s ease-in-out;
        letter-spacing: 10px;
    }
    .number-item:last-child {
        margin-right: 0;
    }
}






</style>


// WEBPACK FOOTER //
// src/view/developMap/index.vue